import { Reducer } from 'react';
import { CandidatesAction, CandidatesState } from './types';
import { candidatesTableColumn } from './config';
import {
  addAllPageItems,
  addSelected,
  removeAllPageItems,
  removeAllSelectedItems,
  removeSelected
} from '../../NewUI/Components/GenericTable/tableHelper';

export const InitialCandidatesState: CandidatesState = {
  snackbar: {
    message: '',
    state: 'success'
  },
  candidatesTableState: {
    canScroll: [false, true],
    tableHovered: false,
    density: 'Default',
    columns: candidatesTableColumn,
    selectedItemIds: [],
    selectedItems: [],
    actions: {
      selectedItem: null,
      anchorEl: null,
      isOpen: {
        delete: false,
        edit: false
      }
    },
    modalsOpen: { edit: false }
  },
  candidatesTableSettings: {
    page: Number(sessionStorage.getItem(`candidatesTablePage`)) || 1,
    limit: 10,
    sort: 'firstname',
    sort_order: 'asc'
  },
  searchQuery: ''
};

export const CandidatesReducer: Reducer<CandidatesState, CandidatesAction> = (
  state: CandidatesState,
  action: CandidatesAction
) => {
  switch (action.type) {
    case 'SET_SNACKBAR':
      return { ...state, snackbar: action.payload };
    case 'SET_SEARCH_QUERY':
      return {
        ...state,
        candidatesTableSettings: { ...state.candidatesTableSettings, page: 1 },
        searchQuery: action.payload
      };
    case 'SET_DENSITY':
      return {
        ...state,
        candidatesTableState: {
          ...state.candidatesTableState,
          density: action.payload
        }
      };
    case 'SET_CAN_SCROLL':
      return {
        ...state,
        candidatesTableState: {
          ...state.candidatesTableState,
          canScroll: action.payload
        }
      };
    case 'SET_TABLE_HOVERED':
      return {
        ...state,
        candidatesTableState: {
          ...state.candidatesTableState,
          tableHovered: action.payload
        }
      };
    case 'SET_SORT':
      return {
        ...state,
        candidatesTableSettings: {
          ...state.candidatesTableSettings,
          sort: action.payload.sortBy,
          sort_order: action.payload.sortOrder
        }
      };
    case 'SET_PAGE':
      return {
        ...state,
        candidatesTableSettings: {
          ...state.candidatesTableSettings,
          page: action.payload
        }
      };
    case 'SET_LIMIT':
      return {
        ...state,
        candidatesTableSettings: {
          ...state.candidatesTableSettings,
          limit: action.payload
        }
      };
    case 'SELECT_ACTION_ITEM':
      return {
        ...state,
        candidatesTableState: {
          ...state.candidatesTableState,
          actions: {
            ...state.candidatesTableState.actions,
            selectedItem: action.payload.item,
            anchorEl: action.payload.anchorEl,
            isOpen: {
              ...state.candidatesTableState.actions.isOpen,
              [action.payload.name]: true
            }
          }
        }
      };
    case 'ADD_SELECTED_ITEM':
      return {
        ...state,
        candidatesTableState: {
          ...state.candidatesTableState,
          ...addSelected(
            state.candidatesTableState.selectedItems,
            state.candidatesTableState.selectedItemIds,
            action.payload
          )
        }
      };
    case 'REMOVE_SELECTED_ITEM':
      return {
        ...state,
        candidatesTableState: {
          ...state.candidatesTableState,
          ...removeSelected(
            state.candidatesTableState.selectedItems,
            state.candidatesTableState.selectedItemIds,
            action.payload
          )
        }
      };
    case 'ADD_ALL_PAGE_ITEMS':
      return {
        ...state,
        candidatesTableState: {
          ...state.candidatesTableState,
          ...addAllPageItems(state.candidatesTableState.selectedItems, action.payload)
        }
      };
    case 'REMOVE_ALL_PAGE_ITEMS':
      return {
        ...state,
        candidatesTableState: {
          ...state.candidatesTableState,
          ...removeAllSelectedItems(
            state.candidatesTableState.selectedItems,
            state.candidatesTableState.selectedItemIds
          )
        }
      };
    case 'CLOSE_ACTION_ITEM':
      return {
        ...state,
        candidatesTableState: {
          ...state.candidatesTableState,
          actions: {
            ...state.candidatesTableState.actions,
            selectedItem: null,
            isOpen: {
              ...state.candidatesTableState.actions.isOpen,
              [action.payload]: false
            },
            anchorEl: null
          }
        }
      };
    default:
      return state;
  }
};
